import * as React from 'react';
import ExerciseCard from '../components/ExerciseCard/ExerciseCard';
import './DomainExercisesCard.scss';

export interface IDomainExercisesCardProps {
  exerciseId: string;
  workoutId: number;
  locked: boolean;
  comparison: number | null;
  balancingJson?: string;
  loading?: boolean;
  numberOfColumns?: number;
}

export const DomainExercisesCard: React.FC<IDomainExercisesCardProps> = ({
  exerciseId,
  workoutId = 0,
  locked,
  comparison,
  balancingJson,
  loading,
  numberOfColumns = 4,
}) => {
  const subtitle = balancingJson ? <span className="balancing-label">{balancingJson}</span> : undefined;
  const columnClass = `col-${Math.floor(12 / numberOfColumns)}`;

  const cardProps = {
    exerciseId,
    comparison: loading ? null : comparison,
    locked,
    workoutId,
    subtitle,
    className: `domain-exercises-card ${columnClass}`,
    id: `${exerciseId}-${workoutId}`,
  };
  return <ExerciseCard {...cardProps} />;
};

export default DomainExercisesCard;
